module.exports = __webpack_public_path__ + "static/media/watch_nav_nike.0c3f8c16.svg";